namespace Solovis.Site.ActionBar {

    export var _actionBarContainer = null;
    export var _regionNameToRegionMap = {};


    export function getOrCreateRegion(regionName) {
        if (!ActionBar._actionBarContainer) {
            ActionBar._actionBarContainer = $("#header-title-bar .action-bar-container");
        }

        if (ActionBar._regionNameToRegionMap[regionName]) {
            return ActionBar._regionNameToRegionMap[regionName];
        }
        else {
            var regionDiv = $("<div>").addClass("action-bar-region").appendTo(this._actionBarContainer);

            var region = new Solovis.Site.ActionBarRegion({
                name: regionName,
                container: regionDiv
            });

            ActionBar._regionNameToRegionMap[regionName] = region;

            return region;
        }
    };

}

namespace Solovis.Site {

    export class ActionBarRegion {

        public name;
        public container;

        constructor(options) {
            this.name = options.name;
            this.container = options.container;
        }

        public setHtml(html) {
            this.container.html(html);
        }

        public destroy() {
            this.container.remove();
            if (ActionBar._regionNameToRegionMap[this.name]) {
                delete ActionBar._regionNameToRegionMap[this.name];
            }
        }
    }    

}